/**
 * Today's date as 'YYYY-MM-DD' in South Africa, for a form's default value.
 *
 * Only a default a person sees and can change -- every date the server stamps
 * comes from the database's own clock in Africa/Johannesburg, never from here.
 * 'en-CA' is used for its YYYY-MM-DD shape, not its locale.
 */
export function todayIso(): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Africa/Johannesburg',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date())
}
